export const RCODES = {
  INVALID_REQUEST_NUMBER: 4000011,
  GK_DUPLICATE_REQUEST: 6000006,
};
